import React, { useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./FAQ.css";

const PlusIcon = ({ open }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    {/* Horizontal bar — always shown */}
    <rect
      x="1"
      y="5.25"
      width="10"
      height="1.5"
      rx="0.75"
      fill={open ? "#fff" : "#6b7280"}
    />
    {/* Vertical bar — only shown when closed (+), hidden when open (−) */}
    {!open && (
      <rect x="5.25" y="1" width="1.5" height="10" rx="0.75" fill="#6b7280" />
    )}
  </svg>
);

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={`faq-item${open ? " faq-item--open" : ""}`}>
      <button className="faq-question" onClick={() => setOpen((o) => !o)}>
        <span className="faq-question-text">{question}</span>
        <span className="faq-toggle">
          <PlusIcon open={open} />
        </span>
      </button>
      <div className="faq-answer-wrap">
        <div className="faq-answer-inner">
          <p className="faq-answer">{answer}</p>
        </div>
      </div>
    </div>
  );
};

const FAQ = ({ sections = [], showSearch = true }) => {
  const [search, setSearch] = useState("");

  const filtered = sections
    .map((section) => ({
      ...section,
      questions: section.questions.filter((q) => {
        if (!search) return true;
        const term = search.toLowerCase();
        return (
          q.question.toLowerCase().includes(term) ||
          q.answer.toLowerCase().includes(term)
        );
      }),
    }))
    .filter((section) => section.questions.length > 0);

  return (
    <div className="faq-wrapper">
      {true && (
        <div className="faq-search-wrap">
          <Input
            className="faq-search-input"
            placeholder="Search questions..."
            prefix={<SearchOutlined />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            allowClear
          />
        </div>
      )}

      {filtered.map((section) => (
        <div key={section.id} className="faq-section">
          {sections.length > 1 && (
            <div className="faq-section-title">{section.title}</div>
          )}
          <div className="faq-card">
            {section.questions.map((q) => (
              <FAQItem key={q.id} question={q.question} answer={q.answer} />
            ))}
          </div>
        </div>
      ))}

      {filtered.length === 0 && search && (
        <p className="faq-empty">No results found for &quot;{search}&quot;</p>
      )}
    </div>
  );
};

export default FAQ;
